function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z  M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.a137131d.svg";
export { ForwardRef as ReactComponent };